module.exports = __webpack_public_path__ + "static/media/icon-complete.fa49ef3a.svg";